import { LiquidSet } from 'client/app/apps/disco-prototype/state/liquidSet';
import { convertActions } from 'client/app/apps/disco-prototype/state/request/instructions';
import { convertLiquidSet } from 'client/app/apps/disco-prototype/state/request/liquidSet';
import { State } from 'client/app/apps/disco-prototype/state/state';
import { Step } from 'client/app/apps/disco-prototype/state/steps';
import { Table } from 'client/app/apps/disco-prototype/state/table';
import {
  CalculateVolumesRequest,
  CalculateVolumesResponse,
} from 'common/types/disco/calculateVolumes';
import { manualDeviceConfig } from 'common/types/disco/device';
/**
 * convertStateToRequest accepts a state object and returns
 *   1) a 'CalculateVolumesRequest' object, which can be passed to the 'calculateVolumes' endpoint for backend
 *      processing
 *   2) a function ('handleResponse') which takes the response from 'calculateVolumes' and returns the
 *      new tables and steps. The original state is not modified
 */
export const convertStateToRequest = (
  state: State,
): {
  request: CalculateVolumesRequest;
  handleResponse: (response: CalculateVolumesResponse) => {
    tables: Table[];
    liquidSets: LiquidSet[];
    steps: Step[];
  };
} => {
  const { instructions, updateSteps } = convertActions(state.steps);

  return {
    request: {
      tables: state.tables.map(table => {
        const { compiled: _, ...ret } = table;
        return ret;
      }),
      liquidSets: state.liquidSets.map(convertLiquidSet),
      instructions,
      device: manualDeviceConfig(),
    },
    handleResponse: response => {
      // one compiled table is produced for each table, update the values
      const tables = state.tables.map(table => ({
        ...table,
        compiled: response.data.tables.find(c => c.id === table.id),
      }));
      const liquidSets = state.liquidSets.map(ls => ({
        ...ls,
        table: tables.find(t => t.id === ls.table.id) ?? ls.table,
      }));
      const steps = updateSteps(state.steps, liquidSets, response.data.instructions);

      return {
        tables,
        liquidSets,
        steps,
      };
    },
  };
};
